import { useState } from "react";

import { Card } from "../../../common/Atoms/Card";
import { MultiButtonCardHeader } from "../../../common/Atoms/MultiButtonCardHeader";
import { Heading } from "../../../common/Atoms/Typography/Heading";
import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";
import { ESCALATIONS_ARTICLE } from "../../constants/links";

import { EscalationTable } from "./EscalationTable";
import { RaiseEscalationModal } from "./RaiseEscalationModal";

export function EscalationsRoot() {
  const [raiseEscalationOpen, setRaiseEscalationOpen] = useState(false);

  return (
    <Card>
      <MultiButtonCardHeader
        noDivider
        title={ (
          <Heading>
            { `Escalations ` }
            <Paragraph
              as={ `span` }
              variant={ `link` }>
              <a
                href={ ESCALATIONS_ARTICLE }
                target={ `_blank` }
                rel={ `noopener noreferrer` }
              >
                { `(How Escalations Work)` }
              </a>
            </Paragraph>
          </Heading>
        ) }
        buttons={ [{
          buttonText: `Raise Escalation`,
          onClick: () => setRaiseEscalationOpen(true),
        }] }
      />
      <EscalationTable />
      <RaiseEscalationModal
        open={ raiseEscalationOpen }
        setOpen={ setRaiseEscalationOpen }
      />
    </Card>
  );
}
